import PropTypes from "prop-types";
import React, {Component} from "react";
import {getCookie, removePipes} from "@core-ui/utility";
import {fetchPersonalization} from "./collaborators/fetch-personalization";
import dataLayerBuilder from "./datalayer/builder";

const personalizationData = {
  isLoading: true,
  isEmpty: true,
  isError: false,
  personalizationReferrerInfo: {},
  shoppingBag: {
    totalItemCount: 0,
  },
};

export const PersonalizationContext = React.createContext(personalizationData);

const reportNREvent = (data) => {
  if (window.newrelic) {
    window.newrelic
      .interaction()
      .setAttribute("JSESSIONID", getCookie("JSESSIONID") || "")
      .setAttribute(
        "unknownShopperId",
        removePipes(getCookie("unknownShopperId"))
      )
      .setAttribute("s_vi", getCookie("s_vi") || "")
      .save();
  }
  return data;
};

export class PersonalizationProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {value: personalizationData};
    this.getData = this.getData.bind(this);
    this.updateBagCount = this.updateBagCount.bind(this);
  }

  componentDidMount() {
    document.addEventListener(
      "updateBagCount",
      (e) => {
        this.updateBagCount(e);
      },
      false
    );

    const dataPromise = this.getData();
    const {datalayer} = this.props;

    dataLayerBuilder({
      datalayer,
      dataPromise,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Allow for Object deep comparison instead of shallow

    const stateChange =
      JSON.stringify(nextState) !== JSON.stringify(this.state);
    return nextProps !== this.props || stateChange;
  }

  componentWillUnmount() {
    document.removeEventListener("updateBagCount", this.updateBagCount);
  }

  getData() {
    const {errorLogger, marketAgnosticBrandCode} = this.props;

    return fetchPersonalization({
      marketAgnosticBrandCode,
      errorLogger,
    })
      .then(reportNREvent)
      .then((data) => {
        this.setState((prevState) => ({
          value: {
            ...prevState.value,
            ...data,
            isLoading: false,
            isEmpty: false,
            isError: false,
          },
        }));
        return data;
      })
      .catch(() => {
        this.setState((prevState) => ({
          ...prevState,
          value: {
            ...prevState.value,
            isError: true,
            isLoading: false,
          },
        }));
      });
  }

  updateBagCount(data) {
    this.setState((prevState) => {
      const shoppingBag = {
        totalItemCount: data.detail.quantity,
        totalItemAmount: prevState.value.shoppingBag.totalItemAmount,
      };
      return {
        value: {
          ...prevState.value,
          shoppingBag,
        },
      };
    });
  }

  render() {
    const {children} = this.props;
    const {value} = this.state;

    return (
      <PersonalizationContext.Provider value={value}>
        {children}
      </PersonalizationContext.Provider>
    );
  }
}

const propTypes = {
  children: PropTypes.node.isRequired,
  datalayer: PropTypes.shape({}).isRequired,
  errorLogger: PropTypes.func.isRequired,
  marketAgnosticBrandCode: PropTypes.number,
};

PersonalizationProvider.propTypes = propTypes;
PersonalizationProvider.defaultProps = {
  marketAgnosticBrandCode: 1,
};
